import {
  GroupTextField,
  GroupTextFieldRow,
  Heading,
  TextField,
} from "@elaniintc/goes-design-system";
import { DCActionSelector } from "./components/action-selector";
import { DCTableSelector } from "./components/table-selector";
import { DCReadForm } from "./forms/read-form";
import { DCCreateForm } from "./forms/create-form";
import { cn } from "@/utils/theme";
import { DCRemoveForm } from "./forms/remove-form";
import { DCUpdateForm } from "./forms/update-form";
import { useDataCenterNode } from "./context";

export const DataCenterNode = () => {
  const {
    reset,
    variableName,
    setVariableName,
    isVariableNameValid,
    variableNameError,
    selectedTable,
    selectedAction,
    setSelectedAction,
    multipleSelected,
    executeQuery,
    setExecuteQuery,
    setMultipleSelected,
  } = useDataCenterNode();

  return (
    <div className="py-3 flex flex-col gap-3">
      <GroupTextField
        label="Tabla y operación"
        required
        className={cn(
          "w-full pt-3 pb-6 px-4",
          selectedTable && selectedAction && "border-b-1 border-neutral-quiet",
        )}
        helperText="Trae todos los registros de la tabla para ser leídos."
      >
        <GroupTextFieldRow>
          {/* tables */}
          <DCTableSelector />
          {/* Actions */}
          <DCActionSelector
            disabled={!selectedTable}
            readonly={selectedTable?.source !== "sdt"}
            selected={selectedAction}
            onActionSelection={(action) => {
              setSelectedAction(action);
              reset();
            }}
          />
        </GroupTextFieldRow>
      </GroupTextField>
      {!!selectedTable && selectedAction?.id === "read" && (
        <DCReadForm
          executeQuery={executeQuery}
          setExecuteQuery={setExecuteQuery}
          multipleSelected={multipleSelected}
          setMultipleSelected={setMultipleSelected}
        />
      )}
      {!!selectedTable && selectedAction?.id === "create" && <DCCreateForm />}
      {!!selectedTable && selectedAction?.id === "update" && <DCUpdateForm />}
      {!!selectedTable && selectedAction?.id === "delete" && <DCRemoveForm />}
      {!!selectedTable && !!selectedAction && (
        <div className="w-full pt-3 pb-6 px-4 flex flex-col gap-4">
          <Heading variant="h6">Variable creada</Heading>
          <TextField
            label="Nombre de la variable"
            required
            placeholder="Escribe el nombre de la variable"
            helperText={
              "Elige un nombre para la variable que crearás en este nodo."
            }
            value={variableName}
            error={
              !isVariableNameValid && variableName
                ? variableNameError || "Nombre inválido"
                : undefined
            }
            maxLength={255}
            onChange={(e) => setVariableName(e.target.value)}
          />
        </div>
      )}
    </div>
  );
};
